import { PlusOutlined } from '@ant-design/icons';
import Colors from './Colors';

export const tags = [
  {
    id: 1,
    name: 'Principiante',
    englishName: 'Beginner',
    language: 'es',
    color: Colors.green,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/78_thumb.jpg`,
    suggestedGrades: ['K', '1', '2'],
  },
  {
    id: 2,
    name: 'Emergente',
    englishName: 'Emerging',
    language: 'es',
    color: Colors.lightBlue,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/58_thumb.jpg`,
    suggestedGrades: ['3', '4'],
  },
  {
    id: 3,
    name: 'Intermedio',
    englishName: 'Intermediate',
    language: 'es',
    color: Colors.orange,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/66_thumb.jpg`,
    suggestedGrades: ['5', '6'],
  },
  {
    id: 4,
    name: 'Avanzado',
    englishName: 'Advanced',
    language: 'es',
    color: Colors.red,
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/161/cover.webp`,
    suggestedGrades: [
      <span key="grade">
        6 <PlusOutlined />
      </span>,
    ],
  },
];

export const tagsWithAll = [
  {
    id: 'all',
    img: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/production/themes/161/cover.webp`,
    suggestedGrades: ['All'],
  },
  ...tags,
];
